import React, { useState } from "react";
import { Container, Form, Row, Button, Col, Tabs, Tab } from "react-bootstrap";
import { Stepper, Step } from "react-form-stepper";

import moment from "moment";
import { ReactComponent as OrderSvg } from "./../assets/icons/Order.svg";
import { ReactComponent as ShipSvg } from "./../assets/icons/Ship.svg";
import { ReactComponent as SignSvg } from "./../assets/icons/Sign.svg";
import { ReactComponent as WarehouseSvg } from "./../assets/icons/Warehouse.svg";
import { ReactComponent as WaybillSvg } from "./../assets/icons/Waybill.svg";

import WaybillInfo from "./WaybillInfo";
import CargoInfo from "./CargoInfo";
import CustomerInfo from "./CustomerInfo";
import styles from "./track-page.module.css";
import "../App.css";
import { useLocation } from "react-router-dom";
import "./track-page.css";

import DropdownIcon from "./../assets/imgs/dropdownicon_down.png";
import DropdownUpIcon from "./../assets/imgs/dropdownicon_up.png";

const TrackingPage = () => {
  const [search, setSearch] = React.useState();
  const [veriCode, setVeriCode] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [notFound, setNotFound] = React.useState(false);
  const [disabled, setDisabled] = React.useState(true);
  const [passVeri, setPassVeri] = React.useState(false);
  const [isWayBillInfoOpen, setisWayBillInfoOpen] = useState(false);

  const waybillToggle = (event) => {
    setisWayBillInfoOpen(!isWayBillInfoOpen);
  };
  const [isItemOpen, setisItemOpen] = useState(false);

  const itemToggle = (event) => {
    setisItemOpen(!isItemOpen);
  };
  const [isCustomerInfoOpen, setisCustomerInfoOpen] = useState(false);

  const customerInfoToggle = (event) => {
    setisCustomerInfoOpen(!isCustomerInfoOpen);
  };
  const location = useLocation().search;
  const onFillVerification = () => {
    setDisabled(true);
    let phones = [
      data.sender.phone.substr(data.sender.phone.length - 4),
      data.receiver.phone.substr(data.receiver.phone.length - 4),
    ];
    if (phones.includes(veriCode)) {
      setPassVeri(true);
    } else {
      alert("Code is invalid");
    }
  };

  const onSearch = async (waybillnumber) => {
    let searchValue = search || waybillnumber;
    if (searchValue.length > 0) {
      try {
        setLoading(true);
        let response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/frontend/get-waybill-tracking?waybill_number=${searchValue}`
        );
        let data = await response.json();

        if (data === "Waybill number not found") {
          setNotFound(true);
          setLoading(false);
          setData(null);
          return;
        } else {
          setDisabled(false);
        }

        setData(data);
        setLoading(false);
        setNotFound(false);
      } catch {
        setData(null);
        setLoading(false);
        setNotFound(true);
      }
    }
  };

  const getStepTitle = (status) => {
    switch (status) {
      case "ORDERCREATED":
        return "Prepare Order Form";

      case "WAYBILLCREATED":
        return "Received at Warehouse";

      case "WAYSTARTED":
        return "Ready to ship";

      case "WAYENDED":
        return "Arrived at Warehouse";

      case "SIGNED":
        return "Signed";
      case "COMMENT":
        return "Waybill Status";

      default:
        return "";
    }
  };

  const getStepIcon = (status) => {
    switch (status) {
      case "ORDERCREATED":
        return <OrderSvg className="svg" />;

      case "WAYBILLCREATED":
        return <WaybillSvg className="svg" />;

      case "WAYSTARTED":
        return <ShipSvg className="svg" />;
      case "WAYENDED":
        return <WarehouseSvg className="svg" />;

      case "SIGNED":
        return <SignSvg className="svg" />;
      case "COMMENT":
        return <SignSvg className="svg" />;

      default:
        return "";
    }
  };

  const getSubStepTitle = (status, stepData) => {
    switch (status) {
      case "ORDERCREATED":
        return data.createdBranch?.name;

      case "WAYBILLCREATED":
        return data.createdBranch?.name;

      case "WAYSTARTED":
        return ``;

      case "WAYENDED":
        return data.destination?.name;

      case "SIGNED":
        return `Signed by ${stepData?.info?.sign_info?.name}`;
      case "COMMENT":
        return stepData.content;

      default:
        return "";
    }
  };

  React.useEffect(() => {
    const waybillnumber = new URLSearchParams(location).get("waybillnumber");

    if (waybillnumber) {
      setSearch(waybillnumber);
      onSearch(waybillnumber);
    }
  }, [location]);

  // React.useEffect(() => {
  //   async function fetchData() {
  //     if (searchParams.get("waybill_number")) {
  //       try {
  //         setLoading(true);
  //         let response = await fetch(
  //           `${
  //             process.env.REACT_APP_BASE_URL
  //           }/frontend/get-waybill-tracking?waybill_number=${searchParams.get(
  //             "waybill_number"
  //           )}`
  //         );
  //         let data = await response.json();

  //         if (data === "Waybill number not found") {
  //           setNotFound(true);
  //           setLoading(false);
  //           setData(null);
  //           return;
  //         }

  //         setData(data);
  //         setLoading(false);
  //         setNotFound(false);
  //       } catch {
  //         setData(null);
  //         setLoading(false);
  //         setNotFound(true);
  //       }
  //     }
  //   }
  //   fetchData();
  // }, [searchParams]);

  return (
    <div>
      <section className={styles.content}>
        <div className={styles.backdrop}>
          <h2>Track Your Shipment</h2>
        </div>
      </section>
      <Container>
        <Row className={styles.tracking_search_row}>
          <Container>
            <h4 className={styles.tracking_title}>Cargo Tracking</h4>
          </Container>
          <Col md={4} className={styles.tracking_search_col}>
            <div className={styles.adjust_size_Wrapper}>
              <Form.Control
                placeholder="Waybill number"
                disabled={!disabled}
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div>
          </Col>
          {!disabled && (
            <Col md={4} className={styles.tracking_search_col}>
              <div className={styles.adjust_size_Wrapper}>
                <Form.Control
                  placeholder="Verification code"
                  onChange={(e) => {
                    setVeriCode(e.target.value);
                  }}
                />
                <p style={{ color: "rgb(164 158 174)" }}>
                  Enter last 4 digits of shipper's or consignee's phone
                </p>
              </div>
            </Col>
          )}
          <Col md={4} className={styles.tracking_search_col}>
            <div className={styles.adjust_size_Wrapper}>
              <Button
                style={{ backgroundColor: "#1A2753" }}
                className={styles.tracking_search_btn}
                onClick={disabled ? onSearch : onFillVerification}
              >
                {!disabled ? "Confirm" : loading ? "Searching.." : "Search"}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid className={styles.tracking_container}>
        {loading ? (
          <Container
            style={{ paddingTop: 20, paddingBottom: 20, textAlign: "center" }}
          >
            Loading
          </Container>
        ) : (
          <>
            {notFound && (
              <Container
                style={{
                  paddingTop: 50,
                  paddingBottom: 50,
                  textAlign: "center",
                }}
              >
                <h4 style={{ color: "red" }}>Waybill Number Not Found</h4>
              </Container>
            )}

            {!notFound && data && passVeri && (
              <>
                <Container className={styles.tabs_container}>
                  <Tabs defaultActiveKey="waybill">
                    <Tab eventKey="waybill" title="Waybill Information">
                      <WaybillInfo data={data} isOpen={true} />
                    </Tab>
                    <Tab eventKey="cargo" title="Item Information">
                      <CargoInfo data={data} isOpen={true} />
                    </Tab>
                    <Tab eventKey="customer" title="Customer Information">
                      <CustomerInfo data={data} isOpen={true} />
                    </Tab>
                  </Tabs>
                  <hr />
                </Container>
                <Container className={styles.collapse_container}>
                  <Row className="justify-content-center">
                    <Button
                      onClick={waybillToggle}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span>Waybill Information</span>
                      <img
                        src={isWayBillInfoOpen ? DropdownUpIcon : DropdownIcon}
                        width={20}
                        height={20}
                      />
                    </Button>
                    <WaybillInfo data={data} isOpen={isWayBillInfoOpen} />
                  </Row>
                  <Row className="mt-3 justify-content-center">
                    <Button
                      onClick={itemToggle}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span>Item Information</span>{" "}
                      <img
                        src={isItemOpen ? DropdownUpIcon : DropdownIcon}
                        width={20}
                        height={20}
                      />
                    </Button>
                    <CargoInfo data={data} isOpen={isItemOpen} />
                  </Row>
                  <Row className="mt-3 justify-content-center mb-5">
                    <Button
                      onClick={customerInfoToggle}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span> Customer Information</span>
                      <img
                        src={isCustomerInfoOpen ? DropdownUpIcon : DropdownIcon}
                        width={20}
                        height={20}
                      />
                    </Button>
                    <CustomerInfo data={data} isOpen={isCustomerInfoOpen} />
                  </Row>
                </Container>
                <Container className="pb-3 desktop-tracking-log">
                  <Stepper complete>
                    {data.logs?.map((step) => (
                      <Step
                        label={getStepTitle(step.status)}
                        children={
                          <div>
                            <span>{getStepIcon(step.status)}</span>
                            <p className="sub-title-tracking">
                              {moment(step.createdAt).format("MMM D")} /{" "}
                              {moment(step.createdAt).format("HH:mm")}
                            </p>
                            <p className="sub-title-tracking2">
                              {getSubStepTitle(step.status, step)}
                            </p>
                          </div>
                        }
                      />
                    ))}
                  </Stepper>
                </Container>
                <Container className="mobile-tracking-log">
                  <nav
                    className="nav nav-pills flex-column"
                    style={{ marginLeft: "20px" }}
                  >
                    {data.logs.map((step) => (
                      <a className="nav-link" href="#">
                        <div className="nav-container">
                          <div className="left-info">
                            <span>
                              {moment(step.createdAt).format("MMM D")}
                            </span>
                            <br />
                            <span>
                              {moment(step.createdAt).format("HH:mm")}
                            </span>
                          </div>
                          <div className="icon">{getStepIcon(step.status)}</div>
                        </div>
                        <div className="right-info">
                          <h5>{getStepTitle(step.status)}</h5>
                          <p>{getSubStepTitle(step.status, step)}</p>
                        </div>
                      </a>
                    ))}
                  </nav>
                </Container>
              </>
            )}
          </>
        )}
      </Container>
      <div style={{ height: "50px" }}></div>
    </div>
  );
};

export default TrackingPage;

// import React from "react";
// import { Container, Form, Row, Button, Col } from "react-bootstrap";
// import { BsPrinterFill } from "react-icons/bs";
// import { useSearchParams } from "react-router-dom";
// import moment from "moment";
// import { ReactComponent as OrderSvg } from "./../assets/icons/Order.svg";
// import { ReactComponent as ShipSvg } from "./../assets/icons/Ship.svg";
// import { ReactComponent as SignSvg } from "./../assets/icons/Sign.svg";
// import { ReactComponent as WarehouseSvg } from "./../assets/icons/Warehouse.svg";
// import { ReactComponent as WaybillSvg } from "./../assets/icons/Waybill.svg";
// import { ReactComponent as ArrowSvg } from "./../assets/icons/arrow.svg";

// import "./track-page.css";

// const TrackingPage = () => {
//   const [searchParams] = useSearchParams();
//   const [search, setSearch] = React.useState();
//   const [data, setData] = React.useState(null);
//   const [loading, setLoading] = React.useState(false);
//   const [notFound, setNotFound] = React.useState(false);

//   const onSearch = () => {
//     if (search.length > 0) {
//       window.location = `/tracking?waybill_number=${search}`;
//     }
//   };

//   const getStepTitle = (status) => {
//     switch (status) {
//       case "ORDERCREATED":
//         return "Prepare Order Form";

//       case "WAYBILLCREATED":
//         return "Received at Warehouse";

//       case "WAYSTARTED":
//         return "Ready to ship";

//       case "WAYENDED":
//         return "Arrived at Warehouse";

//       case "SIGNED":
//         return "Signed";

//       default:
//         return "";
//     }
//   };

//   const getStepIcon = (status) => {
//     switch (status) {
//       case "ORDERCREATED":
//         return <OrderSvg className="svg" />;

//       case "WAYBILLCREATED":
//         return <WaybillSvg className="svg" />;

//       case "WAYSTARTED":
//         return <ShipSvg className="svg" />;
//       case "WAYENDED":
//         return <WarehouseSvg className="svg" />;

//       case "SIGNED":
//         return <SignSvg className="svg" />;

//       default:
//         return "";
//     }
//   };

//   const getSubStepTitle = (status, stepData) => {
//     switch (status) {
//       case "ORDERCREATED":
//         return `Your items have opened order form by our customer service`;

//       case "WAYBILLCREATED":
//         return `Your items have opened waybill voucher and received by our warehouse`;

//       case "WAYSTARTED":
//         return `Your items [${stepData?.info?.issued_info?.qty}] Qty have succeed load our container and ready to shipping`;

//       case "WAYENDED":
//         return `You items [${stepData?.info?.issued_info?.qty}] Qty have arrived to ${stepData?.info?.branch?.name} warehouse`;

//       case "SIGNED":
//         return `Your items [${
//           stepData?.info?.issued_info?.qty
//         }] Qty have received by ${stepData?.info?.sign_info?.name} at ${moment(
//           stepData.createdAt
//         ).format("HH:mm")}`;

//       default:
//         return "";
//     }
//   };

//   React.useEffect(() => {
//     async function fetchData() {
//       if (searchParams.get("waybill_number")) {
//         try {
//           setLoading(true);
//           let response = await fetch(
//             `${
//               process.env.REACT_APP_BASE_URL
//             }/frontend/get-waybill-tracking?waybill_number=${searchParams.get(
//               "waybill_number"
//             )}`
//           );
//           let data = await response.json();
//           data.logs = data.logs.reverse();
//           setData(data);
//           setLoading(false);
//           setNotFound(false);
//         } catch {
//           setData(null);
//           setLoading(false);
//           setNotFound(true);
//         }
//       }
//     }
//     fetchData();
//   }, [searchParams]);

//   return (
//     <div className="py-3">
//       <section>
//         <Container className="my-3">
//           <div className="d-flex justify-content-between align-items-center">
//             <h1>Tracking</h1>
//             <Button variant="info" className="text-white d-sm-block d-none">
//               <BsPrinterFill /> Print
//             </Button>
//           </div>

//           <div>Container/transport document number</div>
//           <Row>
//             <Col md={4} xs={8}>
//               <Form.Control
//                 className="me-auto"
//                 placeholder="Eg. EF123456"
//                 onChange={(e) => {
//                   setSearch(e.target.value);
//                 }}
//               />
//             </Col>
//             <Col md={4} xs={4}>
//               <Button variant="info" className="text-white" onClick={onSearch}>
//                 {loading ? "Searching.." : "Search"}
//               </Button>
//             </Col>
//           </Row>
//           <Row>
//             <Col md={4} xs={8}>
//               <div>
//                 Container number is made of 4 letters and 7 digits. Transport
//                 document number consists of 9 characters.
//               </div>
//             </Col>
//           </Row>
//           {loading ? (
//             <Container
//               style={{ paddingTop: 20, paddingBottom: 20, textAlign: "center" }}
//             >
//               Loading
//             </Container>
//           ) : (
//             <>
//               {!notFound && data && (
//                 <div className="title-box">
//                   <h3>Waybill Number : {data.waybillnumber}</h3>
//                   <div class="info-box">
//                     <div>
//                       <h5>{data.sender.name}</h5>
//                       <p>{data.createdBranch?.name}</p>
//                     </div>
//                     <div style={{ flex: 1 }}>
//                       <ArrowSvg className="arrow-svg" />
//                     </div>
//                     <div>
//                       <h5>{data.receiver.name}</h5>
//                       <p>{data.destination?.name}</p>
//                     </div>
//                   </div>
//                 </div>
//               )}
//               <div className="way-info">
//                 {notFound && (
//                   <Container
//                     style={{
//                       paddingTop: 20,
//                       paddingBottom: 20,
//                       textAlign: "center",
//                     }}
//                   >
//                     <h4 style={{ color: "red" }}>Waybill Number Not Found</h4>
//                   </Container>
//                 )}

//                 {!notFound && data && (
//                   <Container className="pb-3">
// <nav className="nav nav-pills flex-column">
//   {data.logs.map((step) => (
//     <a className="nav-link active" href="#">
//       <div className="nav-container">
//         <div className="left-info">
//           <span>
//             {moment(step.createdAt).format("MMM D")}
//           </span>
//           <br />
//           <span>
//             {moment(step.createdAt).format("HH:mm")}
//           </span>
//         </div>
//         <div className="icon">
//           {getStepIcon(step.status)}
//         </div>
//       </div>
//       <div className="right-info">
//         <h5>{getStepTitle(step.status)}</h5>
//         <p>{getSubStepTitle(step.status, step)}</p>
//       </div>
//     </a>
//   ))}
// </nav>
//                   </Container>
//                 )}
//               </div>
//             </>
//           )}
//         </Container>
//       </section>
//     </div>
//   );
// };

// export default TrackingPage;
